import { render } from "./AddReceptionHC.vue?vue&type=template&id=85caf156&ts=true"
import script from "./AddReceptionHC.vue?vue&type=script&lang=ts"
export * from "./AddReceptionHC.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__